import React, { useEffect, useMemo } from 'react';
import { BngTable } from 'components/bng/ui/BngTable';
import Utils from 'components/Utils';
import useTranslation from 'components/hooks/useTranslation';
import UiBlocker from 'components/bng/ui/UiBlocker';

function ProjectType({ projectType }) {
  const { t } = useTranslation();

  const type = Utils.Project.types[projectType.type];

  return (
    <div className="ProjectType" style={{ color: type.color }}>
      <div className={`badge ${type.badge}`}>{t(type.name)}</div>
    </div>
  );
}

export default function ProjectsTab({ projects, fetchProjects }) {
  const { t } = useTranslation();

  useEffect(() => {
    fetchProjects();
  }, []);

  const cols = useMemo(() => {
    return [
      {
        label: t('id'),
        render: (row) => row.id,
      },
      {
        label: t('name'),
        render: (row) => row.name,
      },
      {
        label: t('caption'),
        render: (row) => Utils.Project.displayName(row),
      },
      {
        label: t('project.type'),
        render: ProjectType,
      },
      {
        label: t('user.type'),
        render: (row) => row.role,
      },
    ];
  }, []);

  return (
    <UiBlocker className="ProjectsTab" block={!projects}>
      <BngTable cols={cols} rows={projects} stickyHeader={true} />
    </UiBlocker>
  );
}
